import React, { useCallback } from 'react';
import type { ParamListBase } from '@react-navigation/native';
import type { NativeStackNavigationProp } from '@react-navigation/native-stack';

import { useSafeNavigation, useSafeRouteParams, useSafeRouter } from '@sg/garnish';

import { useIsExpoRouterEnabled } from '@order/shared/hooks';

import { useIsUpsellScreenEnabled } from '../../hooks';
import { DeliveryCustomization } from './components';

// ─────────────────────────────────────────────────────────────────────────────

export const CustomizationDeliveryScreen = () => {
  const navigation = useSafeNavigation<NativeStackNavigationProp<ParamListBase>>();
  const router = useSafeRouter();
  const isExpoRouterEnabled = useIsExpoRouterEnabled();
  const routeParams = useSafeRouteParams<CustomizationDeliveryScreenRouteParams>();

  const { addressId, productSlug, reorderLineItemId } = routeParams;

  const isUpsellScreenEnabled = useIsUpsellScreenEnabled();

  // ─── Helpers ─────────────────────────────────────────────────────────

  const handleAddLineItemToCart = useCallback(() => {
    if (isUpsellScreenEnabled) {
      if (isExpoRouterEnabled) {
        router?.replace('/upsell');
        return;
      }

      navigation?.replace('UpsellScreen');
      return;
    }

    if (isExpoRouterEnabled) {
      router?.replace({
        pathname: '/bag',
        params: { referrer: 'DeliveryMenu' },
      });
      return;
    }

    navigation?.replace('Bag', { referrer: 'DeliveryMenu' });
  }, [isExpoRouterEnabled, navigation, router, isUpsellScreenEnabled]);

  // ─────────────────────────────────────────────────────────────────────

  return (
    <DeliveryCustomization
      addressId={addressId}
      productSlug={productSlug}
      reorderLineItemId={reorderLineItemId}
      onAddLineItemToCart={handleAddLineItemToCart}
      isEditProductMode={false}
    />
  );
};

// ─── Types ───────────────────────────────────────────────────────────────────

type CustomizationDeliveryScreenRouteParams = {
  addressId: string;
  productSlug: string;
  reorderLineItemId?: string;
};
